import { setBasepath } from 'hookrouter';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { ContextWrappers } from './ContextWrappers';
import { FontStyles } from './fonts';
import reportWebVitals from './reportWebVitals';

const basePath = process.env.BASE_PATH || '/identity';
setBasepath(basePath);
const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <ContextWrappers>
    <FontStyles />
    <App basePath={basePath} />
  </ContextWrappers>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
